
<template>


<div>
  <!-- main study area -->
  <div @click.prevent="handleClick" class="panel-body">
    <div class="microNoteStudier">
      <div class="html">
        <DynamicRenderer ref="html" v-if="microNote" :html="microNote.html" />
      </div>
    </div>
  </div>
</div>

</template>

<script>
import Vue from 'vue'
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'
import DynamicRenderer from './DynamicRenderer'

export default {
  props: ['microNote'],

  components: {
    DynamicRenderer,
  },

  methods: {
    // Somewhere in the main panel body is clicked
    handleClick(e) {
      const $target = $(e.target);

      // Things to ignore clicking on
      if($target.hasClass('clex-keyword')) return;

      this.$store.dispatch('studier/setActiveKeyword', {keyword: null})
    },
  },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.microNoteStudier {
  margin-top: 20px;
}

</style>

<style lang="scss">
.microNoteStudier .html p {
  font-size: 14px;
  line-height: 1.7em;
}

</style>



// WEBPACK FOOTER //
// MicroNoteStudier.vue?057ef6e4